export { default as ProductCarouselInfoText } from "./ProductCarouselInfoText";
